export class LoginModel {
  username?: string;
  password?: string;
  code?: string;
  doNotCloseSession?: string;
}

export class LoginResendEmail {
  email?: string;
}
